import * as types from './actionTypes';

export function setAmexDisputeReasonCode(amexDisputeReasonCode) {
  return { type: types.SET_AMEX_DISPUTE_REASON_CODE, amexDisputeReasonCode };
}
